import Flickity from "flickity";
import { flickitySettleHandler } from "../utils/flickity";
import debounce from "../utils/debounce";

export default class QuoteCarousel {
  constructor(elem) {
    this.elem = elem;
    this.carousel = this.elem.querySelector(".js-slider");
    this.slides = this.elem.querySelectorAll(".js-slide");
    this.slideIndex = this.elem.querySelector(".js-qcarousel-index");
    this.slideTotal = this.elem.querySelector(".js-qcarousel-total");
    this.flkty;
    this.videoPlayers = [];
    this.currentSlideIndex = 0;
    this.windowWidth = window.innerWidth;
  }


  resizeCarousel() {
    if (this.windowWidth != window.innerWidth) {
      this.flkty.destroy();
      this.setupCarousel();

      this.slideHeight = 0;
      this.windowWidth = window.innerWidth;
    }
  }

  setupCarousel() {
    this.flkty = new Flickity(this.carousel, {
      accessibility: false,
      prevNextButtons: this.elem.dataset.length > 1,
      pageDots: false,
      autoPlay: false,
      imagesLoaded: true,
      cellAlign: "left",
      lazyLoad: 2,
      resize: true,
      wrapAround: true,
      draggable: (this.elem.dataset.length > 1) ? true : false,
      on: {
        ready: () => {
          if(this.elem.dataset.length > 1 && this.slideTotal) {
            this.slideTotal.innerText = this.slides.length;
          }
        },
        change: (index) => {
          if(this.elem.dataset.length > 1 && this.slideIndex) {
            this.slideIndex.innerText = index + 1;
          }
          this.currentSlideIndex = index;
        },
        settle: () => {
          flickitySettleHandler(this.carousel.querySelectorAll(".js-slide"));
        },
      },
    });
  }

  init() {
    this.setupCarousel();
    window.addEventListener("resize", debounce(() => this.resizeCarousel(), 200));
  }
}